import type {JSX} from 'react'
import {useNavigate} from 'react-router'
import {homeSelectors} from '../../../store/home/homeSelectors'
import {GLOBAL} from '../../../Translation/English/global'
import {cx} from '../../../utils'
import {useWt, WuIcon} from '@npm-questionpro/wick-ui-lib'
import styles from './Breadcrumbs.module.scss'

export const BreadCrumbs = (): JSX.Element => {
  const breadcrumbs = homeSelectors.useBreadcrumbs()
  const navigate = useNavigate()
  const wt = useWt()

  return (
    <nav
      aria-label={wt(GLOBAL.breadcrumb)}
      className={styles.breadcrumbsContainer}
    >
      {breadcrumbs.map((breadcrumb, index) => {
        const isCurrent = index === breadcrumbs.length - 1
        return (
          <div key={index} className={styles.breadcrumbItem}>
            {isCurrent ? (
              <span
                className={cx(styles.breadcrumbLabel, styles.breadcrumbCurrent)}
                aria-current="page"
              >
                {breadcrumb.label}
              </span>
            ) : (
              <>
                <button
                  type="button"
                  className={styles.breadcrumbLabel}
                  onClick={() => navigate(breadcrumb.path)}
                >
                  {breadcrumb.label}
                </button>
                <WuIcon icon="wm-arrow-forward-ios" className="" />
              </>
            )}
          </div>
        )
      })}
    </nav>
  )
}
